import type { Validations } from "@credit-acceptance/step6-bff-client";
import type { FieldError } from "react-hook-form";

export interface ProductViolations {
  /** Field-level messages keyed by form field name, shaped for the field components' `error` prop. */
  readonly byField: Readonly<Record<string, FieldError>>;
  /** Messages that name no form field (or one this card doesn't have). */
  readonly general: readonly string[];
}

/**
 * Splits the BFF's per-product required and business-rule violations
 * into field-level errors and a general list. A violation's `field` is `vsc.<bff field>` / `gap.<bff field>`;
 * `fieldNames` maps the BFF field to this card's form field.
 * @param validations The product's `validations`.
 * @param fieldNames BFF field name to form field name.
 * @returns {ProductViolations} Grouped messages.
 */
export function groupViolations(
  validations: Validations | undefined,
  fieldNames: Readonly<Record<string, string>>
): ProductViolations {
  const byField: Record<string, FieldError> = {};
  const general: string[] = [];
  for (const violation of [
    ...(validations?.requiredViolations ?? []),
    ...(validations?.businessRuleViolations ?? []),
  ]) {
    const bffField = violation.field?.split(".").pop();
    const formField = bffField ? fieldNames[bffField] : undefined;
    if (formField) {
      byField[formField] ??= { type: violation.code, message: violation.message };
    } else if (!general.includes(violation.message)) {
      general.push(violation.message);
    }
  }
  return { byField, general };
}
